import type { ImportWatchlistCommand, ImportWatchlistResult, WatchlistEntry } from '@sirius/contracts';

import { request } from '../client';

/** Watchlist акаунта в порядку додавання. Кожен запис несе копію лота. */
export const listWatchlist = (): Promise<WatchlistEntry[]> => request<WatchlistEntry[]>('/watchlist');

/** Додати лот. Копію знімає бекенд; повторне додавання нічого не змінює. */
export const addToWatchlist = (vehicleId: string): Promise<WatchlistEntry> =>
	request<WatchlistEntry>(`/watchlist/${encodeURIComponent(vehicleId)}`, { method: 'PUT' });

export const removeFromWatchlist = (vehicleId: string): Promise<void> =>
	request<void>(`/watchlist/${encodeURIComponent(vehicleId)}`, { method: 'DELETE' });

export const clearWatchlist = (): Promise<void> => request<void>('/watchlist', { method: 'DELETE' });

/** Гостьовий список із браузера — в акаунт. */
export const importWatchlist = (command: ImportWatchlistCommand): Promise<ImportWatchlistResult> =>
	request<ImportWatchlistResult>('/watchlist/import', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(command),
	});
